import { Controller } from "@hotwired/stimulus"

// Chat composer key handling. Enter sends the message; Shift+Enter and
// Cmd/Ctrl+Enter insert a newline so you can write a multi-line message.
export default class extends Controller {
  keydown(event) {
    if (event.key !== "Enter" || event.isComposing) return

    // Shift+Enter: let the browser insert a newline (default behavior).
    if (event.shiftKey) return

    // Cmd/Ctrl+Enter: newline too (browsers don't insert one by default here).
    if (event.metaKey || event.ctrlKey) {
      event.preventDefault()
      this._insertNewline(event.target)
      return
    }

    // Plain Enter: send. requestSubmit() runs HTML validation (the textarea is
    // required), so an empty message won't submit.
    event.preventDefault()
    const form = event.target.closest("form")
    if (form) (form.requestSubmit ? form.requestSubmit() : form.submit())
  }

  _insertNewline(el) {
    const start = el.selectionStart ?? el.value.length
    const end   = el.selectionEnd ?? el.value.length
    el.value = el.value.slice(0, start) + "\n" + el.value.slice(end)
    el.selectionStart = el.selectionEnd = start + 1
    el.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
